import { render, staticRenderFns } from "./SubHeaderStaticPage.vue?vue&type=template&id=248ffee8&"
import script from "./SubHeaderStaticPage.vue?vue&type=script&lang=js&"
export * from "./SubHeaderStaticPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports